import { render, staticRenderFns } from "./PagamentoAnexoExcluir.vue?vue&type=template&id=b3922754&"
import script from "./PagamentoAnexoExcluir.vue?vue&type=script&lang=js&"
export * from "./PagamentoAnexoExcluir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports